// extracted by mini-css-extract-plugin
export default {"container":"pC-z","dimension":"qC-z","dimensionLabels":"rC-z"};